import get from 'lodash/get.js';
import PendoAppDisplay from '../../app-display/pendo-app-display.vue.js';
import PendoTooltip from '../../../directives/tooltip/pendo-tooltip.js';
import PendoCheckbox from '../../../components/checkbox/pendo-checkbox.vue.js';
import PendoTable from '../../../components/table/pendo-table.vue.js';
import PendoStatusOverlay from '../../status-overlay/pendo-status-overlay.vue.js';
import PendoGuideElementTypeAction from './guide-element-type-action/pendo-guide-element-type-action.vue.js';

var script = {
  name: 'PendoGuideElementsTable',
  components: {
    PendoGuideElementTypeAction,
    PendoCheckbox,
    PendoTable,
    PendoStatusOverlay,
    PendoAppDisplay
  },
  directives: {
    PendoTooltip
  },
  props: {
    guideStepNames: {
      type: Array,
      required: true
    },
    apps: {
      type: Array,
      default: () => []
    },
    elementsActivityAggStatus: {
      type: String,
      required: true
    },
    loadingOptions: {
      type: Object,
      default: () => {}
    },
    elementsActivity: {
      type: Array,
      required: true
    },
    elementsTableColumns: {
      type: Array,
      required: true
    },
    csvDownloadConfig: {
      type: Object,
      required: true
    },
    isCrossApp: {
      type: Boolean,
      default: false
    },
    borderless: {
      type: Boolean,
      default: false
    },
    grouped: {
      type: Boolean,
      default: true
    },
    showDeleted: {
      type: Boolean,
      default: false
    },
    showHeader: {
      type: Boolean,
      default: true
    },
    height: {
      type: Number,
      default: 600
    }
  },
  emits: ['toggle-grouped', 'toggle-show-deleted', 'on-metric-click'],
  data() {
    return {
      overflowTooltipContent: null
    };
  },
  computed: {
    filters() {
      return [{
        value: this.showDeleted,
        filterFn: row => this.showDeleted || !row.isDeleted
      }];
    },
    groupConfig() {
      const config = {
        enabled: this.grouped,
        groupKey: this.isCrossApp ? ['appId', 'guideStepId'] : 'guideStepId',
        sortChildren: true
      };
      return config;
    },
    groupedLabel() {
      return this.isCrossApp ? 'Group by Step and App' : 'Group by Step';
    }
  },
  methods: {
    checkForOverflowingContent(event, row) {
      this.overflowTooltipContent = null;
      const {
        scrollWidth,
        clientWidth
      } = event.target;
      if (scrollWidth > clientWidth) {
        const tooltipText = this.getGroupByStepAndAppHeaderText(row);
        this.overflowTooltipContent = tooltipText;
      }
    },
    getElementActions(uiElementActions) {
      if (!uiElementActions) {
        return [];
      }
      const elementActions = uiElementActions.map(_ref => {
        let {
          action,
          icon
        } = _ref;
        return {
          name: action,
          icon
        };
      });
      return elementActions;
    },
    getGroupByStepAndAppHeaderText(_ref2) {
      let {
        appId,
        guideStepId
      } = _ref2;
      if (this.isCrossApp && appId) {
        return this.getGroupByAppHeaderText({
          appId
        });
      }
      return this.getGroupByStepHeaderText({
        guideStepId
      });
    },
    getAppById(_ref3) {
      let {
        appId
      } = _ref3;
      const app = this.apps.find(app => app.id.toString() === appId.replace(/-\d+/g, ''));
      return app || null;
    },
    getGroupByAppHeaderText(_ref4) {
      let {
        appId
      } = _ref4;
      if (appId === 'deleted') {
        return 'Deleted Step';
      }
      const app = this.getAppById({
        appId
      });
      return get(app, 'name', null);
    },
    getGroupByStepHeaderText(_ref5) {
      let {
        guideStepId
      } = _ref5;
      const stepNumber = this.guideStepNames.findIndex(step => step.id === guideStepId) + 1;
      if (stepNumber === 0) {
        return 'Deleted Step';
      }
      const {
        name: stepName
      } = this.guideStepNames.find(step => step.id === guideStepId);
      if (stepName) {
        return `Step ${stepNumber} - ${stepName}`;
      }
      return `Step ${stepNumber}`;
    },
    getRowClassName(_ref6) {
      let {
        row
      } = _ref6;
      if (row.isDeleted) {
        return 'is-deleted';
      }
      if (this.isCrossApp && row.isGroup) {
        if (row.appId) {
          return 'is-grouped-by-app';
        }
        return 'is-grouped-by-step';
      }
      return;
    },
    getCellClassName(_ref7) {
      let {
        columnIndex
      } = _ref7;
      if (this.isCrossApp && this.groupByStepAndApp) {
        if (columnIndex === 0) {
          return 'is-guide-element-name';
        }
      }
      return;
    },
    onMetricClick(_ref8) {
      let {
        row
      } = _ref8;
      this.$emit('on-metric-click', row);
    },
    isAppRow(_ref9) {
      let {
        row
      } = _ref9;
      return this.isCrossApp && !!row.appId;
    },
    isStepRow(_ref10) {
      let {
        row
      } = _ref10;
      return !!row.guideStepId;
    }
  }
};

export { script as default };
//# sourceMappingURL=pendo-guide-elements-table.vue2.js.map
